import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import { putRequest } from '../../helpers/apiHandler';
import config from '../../config/Constant';
import CustomAlert from '../CustomAlert';

const RouteNameChangeModel = ({ onShow, data, refreshData, setRouteChangeModelShow }) => {
  const { access_token } = useSelector((state) => state.auth.user);

  const { row, option } = data;
  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });

  const handleClose = () => {
    setRouteChangeModelShow(false);
  };

  const handleUpdate = () => {
    putRequest(
      `/admin/user-gateway-route-update/` + row.user_id,
      { route_name: option },
      access_token.token,
      (res) => {
        if (res.success) {
          refreshData();
          handleClose();
          setAlertState({
            message: 'Successfully updated route name',
            show: true,
            variant: 'success',
          });
        } else {
          setAlertState({
            message: 'There was an issue while updating route name',
            show: true,
            variant: 'danger',
          });
        }
      }
    );
  };

  useEffect(() => {
    if (alertState.show) {
      setTimeout(() => {
        setAlertState({
          message: '',
          show: false,
          variant: '',
        });
      }, config.notify_time);
    }
  }, [alertState]);

  return (
    <>
      <CustomAlert
        message={alertState.message}
        show={alertState.show}
        variant={alertState.variant}
        closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
      />
      <Modal show={onShow} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Change Route Name</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Name: <strong>{row?.user_name}</strong>
          </p>
          <p>
            Email: <strong>{row?.email}</strong>
          </p>
          <p>
            Current route name: <strong>{row?.route_name}</strong>
          </p>
          <hr />
          <p>
            New route name: <strong>{option}</strong>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="ghost" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleUpdate}>
            Approve
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RouteNameChangeModel;
